import { useNavigate } from "react-router-dom";
import { Nav } from "../components";
import { useAppContext } from "../context/useContext";

const Home = () => {
  const navigate = useNavigate();
  const { dark } = useAppContext();

  return (
    <div className="relative w-screen h-screen overflow-hidden">
      <Nav />

      {/* Background dark mode */}
      {dark && (
        <div
          style={{ backgroundImage: `url('/images/bg.png')` }}
          className="fixed inset-0 opacity-70 wave bg-cover"
        />
      )}

      {/* Main content */}
      <div className="relative z-10 flex h-full items-center px-6 md:px-16">
        {/* LEFT CONTENT */}
        <div className="max-w-xl">
          <h1 className="font-bold text-3xl sm:text-4xl md:text-5xl mb-4">
            Kết nối & Quản lý công việc
          </h1>

          <p className="text-sm sm:text-base md:text-lg text-gray-700 dark:text-gray-300">
            Nền tảng giúp bạn kết nối với mọi người, chia sẻ ý tưởng và quản lý
            công việc hiệu quả trong cùng một không gian.
          </p>

          <div className="flex gap-4 mt-8">
            <button
              className="btn-home boxed"
              onClick={() => navigate("/login")}
            >
              Đăng Nhập
            </button>

            <button
              className="btn-home boxed"
              onClick={() => navigate("/register")}
            >
              Đăng Ký
            </button>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <img
          src="images/img-home.png"
          alt="rocket"
          className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 h-[80%] object-contain wave"
        />
      </div>
    </div>
  );
};

export default Home;
